import React from 'react';
import { Link } from 'react-router-dom';
import posed, { PoseGroup } from 'react-pose';
import styled from 'styled-components';
import { NewTabLink, Button } from '../common';
import { GOOGLE_FORM_LINK } from '../../constants';

export default props => (
  <PoseGroup>
    <Navbar key="navbar">
      <NavbarLink to="/">CzechBased</NavbarLink>
      <Navigation>
        <SubmitButton href={GOOGLE_FORM_LINK}>
          <AddButton blue>Přidej projekt!</AddButton>
        </SubmitButton>
      </Navigation>
    </Navbar>
  </PoseGroup>
);

// <AddLink to="/about">Jak to vzniklo?</AddLink>

const AddButton = styled(Button)`
  padding: 12px 24px;
  border-radius: 30px;
`;

const SubmitButton = styled(NewTabLink)`
  @media (max-width: 480px) {
    display: none;
  }
`;

// const AddLink = styled(Link)`
//   color: #186bff;
//   text-decoration: none;
// `;

// const Beta = styled.span`
//   color: ${props => props.theme.secondaryTextColor};
//   font-size: 14px;
// `;

const Item = posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 },
});

const NavbarLink = styled(Link)`
  text-decoration: none;
  align-items: center;
  color: ${props => props.theme.primaryColor};

  font-size: 24px;
  font-weight: bold;
`;

const Navbar = styled(Item)`
  align-items: center;
  font-weight: bold;
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
`;

const Navigation = styled.ul`
  display: flex;
  align-items: center;
  text-transform: uppercase;

  & > * {
    letter-spacing: 1px;
    margin: 8px;
    color: #787878;
    text-decoration: none;
    font-weight: 700;
    font-size: 12px;
    transition: color 0.3s;
  }

  & > *:hover {
    color: ${props => props.theme.primaryColor};
  }
`;
